import { Theme } from '@mui/material';

export default function spacing(theme: Theme, value: number) {
	return Number(theme.spacing(value).replace('px', ''));
}
